import styled from "styled-components";

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  border-radius: 5px;
  padding: 1.5rem 1.125rem;

  background-color: #ffffff;
  border-radius: 10px;
`;

export const CardTitle = styled.h3`
  margin: 0;
  color: #004169;

  font-size: 1.5rem;
  text-align: start;
`;

export const CardDescription = styled.p`
  color: #797979;
  font-size: 1rem;
`;

export const CardButton = styled.button`
  border-radius: 2px;
  padding: 0.75rem 0;
  width: 100%;
  max-width: 20rem;
  
  color: #ffffff;
  background-color: #0a77c6;
  border: none;
  
  font-size: 1rem;

  cursor: pointer;
  transition: filter 200ms ease-in-out;

  &:hover {
    filter: brightness(0.9);
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid #0a77c6;
    outline-offset: 2px;
  }
`;
